<template>
    <popper class="table-popper text-center" :options="{ placement: 'bottom' }" :stop-propagation="true" :trigger="trigger">
      <div class="popper-content">
        <slot />
      </div>

      <i class="fas fa-ellipsis-v cursor-pointer" slot="reference" />
    </popper>
</template>

<script>
import Popper from 'vue-popperjs';

export default {
  name: 'table-popper',
  components: { Popper },
  props: {
    trigger: {
      type: String,
      default: 'clickToToggle',
      validator: (value) => {
        return [
          'clickToToggle', 'hover',
        ].indexOf(value) !== -1;
      },
    },
  },
}
</script>
